import Icon from '../../shared/components/Icons';
import { SmartImg } from '../../shared/components/Layout';
import { Stars } from '../../shared/components/Common';
import { fmtDay } from '../../shared/data/common';
import { freeCancellationText } from './data';

/** Hotel booking summary used on review, confirmation and booking details pages; also reads demo bookings. */
export default function HotelSummary({ summary: s }) {
  const guests = `${s.adults} Adult${s.adults > 1 ? 's' : ''}${s.children ? `, ${s.children} Child${s.children > 1 ? 'ren' : ''}` : ''}`;
  const free = s.cancellation
    ? freeCancellationText(s.cancellation)
    : s.freeCancel && 'Free cancellation till 24 hrs before check-in';
  return (
    <div className="sum">
      <div className="sum-media">
        <div className="sum-thumb"><SmartImg src={s.image} alt={s.name} /></div>
        <div>
          {s.stars > 0 && <Stars n={s.stars} />}
          <h3>{s.name}</h3>
          {s.address && <span className="muted small"><Icon name="pin" size={13} /> {s.address}</span>}
        </div>
      </div>
      <div className="stay-dates">
        <div><span className="muted small">Check-in</span><b>{fmtDay(s.checkin)}</b>{s.checkInTime && <span className="muted small">From {s.checkInTime}</span>}</div>
        <span className="nights-pill">{s.nights} Night{s.nights > 1 ? 's' : ''}</span>
        <div><span className="muted small">Check-out</span><b>{fmtDay(s.checkout)}</b>{s.checkOutTime && <span className="muted small">Until {s.checkOutTime}</span>}</div>
      </div>
      <div className="sum-foot">
        <span><Icon name="hotels" size={14} /> {s.rooms} × {s.roomName} · {s.planName}</span>
        <span><Icon name="user" size={14} /> {guests}</span>
        {free ? <span className="text-primary"><Icon name="check" size={14} /> {free}</span>
          : <span className="text-coral">Non-refundable rate</span>}
        {s.requests && <span><Icon name="file" size={14} /> Requests: {s.requests}</span>}
      </div>
    </div>
  );
}
